import { useContext, useCallback } from 'react'
import { Box, Typography, Fab, Link } from '@aura/components'
import { withStyles } from '@aura/components/styles'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import { useAuraThemeSwitcher } from '@aura/components/themes'
import menuContext from '../../utils/menu-context'
import constants from '../../constants/languages'
import rbcLogoEn from '../../../public/img/logos/rbc/RBC_Capital_Markets_logo_en.svg?url'
import rbcLogoLight from '../../../public/img/logos/rbc/RBC_Capital_Markets_logo_en_light.svg?url'
import rbcLogoFr from '../../../public/img/logos/rbc/RBC_Capital_Markets_logo_fr.svg?url'
import rbcLogoFrLight from '../../../public/img/logos/rbc/RBC_Capital_Markets_logo_light_fr.svg?url'
import SUPPORTED_THEMES from '../../constants/theme'
import styles from './styles'


const Component = ({
    classes,
    moveToTopRef,
}) => {

    const { mobileDevice } = useContext(menuContext)
    const { t: translate, i18n } = useTranslation()
    const { theme } = useAuraThemeSwitcher()
    const handleClick = useCallback(e => {
        const target = moveToTopRef?.current
        target
            ? target.scrollIntoView({ behavior: 'smooth', block: 'start' })
            : window.scroll({ behavior: 'smooth', left: 0, top: 0 })
    }, [ moveToTopRef ])

    const openLogoLink = useCallback(() => {
        window.open(translate('homeLink'), '_blank')
    }, [ translate ])

    const RBC_THEME_BASED_LOGO = {
        [constants.ENGLISH] :{
            [SUPPORTED_THEMES.DARK]:rbcLogoLight,
            [SUPPORTED_THEMES.LIGHT]:rbcLogoEn
        },
        'default':{
            [SUPPORTED_THEMES.DARK]:rbcLogoFrLight,
            [SUPPORTED_THEMES.LIGHT]:rbcLogoFr
        }
    }

    return (
        <div className={`${'M-footerOutter-56'} ${classes.footerOutter}`}>
            
            <div className={classes.footer} direction='column' justify='space-between'>
                <div className={classes.footerRBC} direction='row'>
                    <Box className={clsx(classes.logoContainer)} onClick={openLogoLink}>
                        {i18n.language === constants.ENGLISH ? (
                            <img className={classes.logoEn} src={RBC_THEME_BASED_LOGO[constants.ENGLISH][theme.palette.mode]} />
                        ) : (
                            <img className={classes.logoFr} src={RBC_THEME_BASED_LOGO['default'][theme.palette.mode]} />
                        )}
                    </Box>
                    <Box className={classes.footerRBCText}>
                        <div className={classes.linkBelow}>
                            <Link href={translate('footer.privacylink')} underline='none' target='_blank' className={clsx(classes.link)}>
                                {translate('footer.privacy')}
                            </Link>
                            <span className={classes.divider} />
                            {mobileDevice && <br/>}
                            <Link href={translate('footer.legalDisclaimerLink')} underline='none' target='_blank' className={clsx(classes.link)}>
                                {translate('footer.legalDisclaimer')}
                            </Link>
                            <span className={classes.divider} />
                            {mobileDevice && <br/>}
                            <Link href={translate('footer.accessibilityLink')} underline='none' target='_blank' className={clsx(classes.link)}>
                                {translate('footer.accessibility')}
                            </Link>
                        </div>
                        <div>
                            <Typography className={classes.text}>
                                {translate('footer.footerText')}
                            </Typography>
                        </div>
                    </Box>
                </div>
                <div className={classes.footerCIRO} direction='row'>
                    <Box className={classes.ciroLogo}>
                        <img className={i18n.language === constants.ENGLISH ? classes.ciroImage : classes.ciroImageFr} src={translate(`footer.ciroSrc${theme.palette.mode}`)} />
                    </Box>
                    <Box className={classes.footerCIROText}>
                        <Link className={classes.ciroLink} href={translate('footer.cipfLink')} underline="none" target="_blank" rel="noopener noreferrer">
                            {translate('footer.cipf')}
                        </Link>
                    </Box>
                </div>
            </div>
            <Box  className={classes.topButton}>
    
                <Fab className={classes.fab} onClick={handleClick}>
                    <KeyboardArrowUpIcon fontSize='large' className={classes.keyboardArrowUp} />
                </Fab>
            </Box>
        </div>
    )
}

Component.propTypes = {
    classes: PropTypes.shape({
        grid: PropTypes.object,
        root: PropTypes.object,
    })
}

export default withStyles(Component, styles)
